module.exports = __webpack_public_path__ + "static/img/texun555.23d5532.png";